<template>
  <section class="quote-refer-page">
    <h1>Information Incompatible</h1>
    <span>The plan selected is not compatible with the detailed information given. </span>
    <div class="abs-top-right">
      <v-button @click="handlerBack">Previous</v-button>
    </div>
    <div class="card">
      <div class="flex-sb">
        <span class="max-label">Create Refer Case Support Ticket</span>
        <v-button
          type="primary"
          @click="referNext">Proceed to {{ isReferralRequest? 'convert': 'create' }} Ticket</v-button>
      </div>
    </div>
    <quote-plan-list
      :allQuoteList="allQuoteList"
      :quoteDetailData="quoteDetailData"
      :classId="quoteForm.class_id"
      @buy-policy="handlerBuyPolicy" />
  </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import QuotePlanList from './components/quote-plan-list'
import { saveQuotation, getQuoteAll, getQuoteAllNew } from '@/api/quote'
export default {
  name: 'QuoteRefer',
  components: {
    QuotePlanList
  },
  props: {
    isReferralRequest: {
      type: Boolean,
      default: false
    },
    requestOrderId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      allQuote: [],
      quoteDetailData: []
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('quote', ['quoteForm', 'carModelOptions', 'quoteInformationForm']),
    allQuoteList() {
      return this.allQuote
      // return this.allQuote.filter(item => {
      //   // 还得过滤掉当前的 company id   todo
      //   if(item.is_refer_case === 0 && item.is_error_case === 0) {
      //     return item
      //   }
      // })
    },
    orderId() {
      if(this.isReferralRequest) return this.requestOrderId
      return this.$route.query.order_id
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getQuoteAllNew()
      }
    }
  },
  methods: {
    ...mapActions('quote', ['setQuoteInformationForm']),
    handlerBack() {
      if(this.isReferralRequest) {
        this.$emit('back')
        return
      }
      this.$router.back()
    },
    handlerBuyPolicy(index) {
      let params = JSON.parse(JSON.stringify(this.quoteInformationForm))
      // params = Object.assign(params, this.allQuoteList[index])
      params = {
        ...params,
        ...this.allQuote[index].plan_info
      }
      params.order_id = params.id
      this.network().saveQuotation(params)
    },
    referNext() {
      if(this.isReferralRequest) {
        this.$emit('refer')
        return
      }
      this.$router.push({
        path: '/quoting/quote/refer/information',
        query: {
          order_id: this.orderId,
          product_id: this.productId
        }
      })
    },
    network() {
      return {
        saveQuotation: async params => {
          const { data } = await saveQuotation(params)
          this.setQuoteInformationForm(params)

          if(this.isReferralRequest) {
            this.$emit('success')
            return
          }
          // this.$router.push({
          //   path: '/quoting/payment',
          //   query: {
          //     order_id: this.orderId,
          //     product_id: this.productId
          //   }
          // })
          const {order_id, quo_id} = data.data
          this.$router.push({
            path: '/quoting/information',
            query: {
              order_id,
              quo_id,
              product_id: this.productId,
            }
          })
        },
        getQuoteAll: async () => {
          const { data } = await getQuoteAll({
            ...this.quoteInformationForm,
            order_id: this.orderId
          })
          this.allQuote = data
        },
        getQuoteAllNew: async () => {
          const { data } = await getQuoteAllNew({
            ...this.quoteInformationForm,
            order_id: this.orderId
          })
          this.allQuote = data.list
          this.quoteDetailData = data.detail
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-refer-page {
    position: relative;
    padding-right: 200px;
    min-width: 900px;
    h1 {
      padding-bottom: 5px;
      & + span {
        display: block;
        padding-bottom: 10px;
      }
    }
}
</style>